/**
 * View to input, validate and generate the test scripts
 * @param {object} parameters
 * @param {function} setParameters
 * @param {object} generatedTests the test that was generated for with the parameters
 * @param {function} errorDisplay
 */
import Styles from './TestScript.module.scss';
import { useState } from 'react';

// component imports
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import FeatherIcon from 'feather-icons-react';
import { useTranslation } from 'components/lib';

export function TestScript({ parameters, setParameters, generatedTests, errorDisplay }) {

  const { t } = useTranslation();

  const [currentTab, setCurrentTab] = useState('template')


  function handleTemplateEdit(e) {
    setParameters(prevState => ({
      ...prevState,
      testTemplate: e.target.value
    }))
  }

  function generateScript() {
    if (!generatedTests) {
      errorDisplay(t('Components.NodeLayout.CombinatorialTestPane.testScript.error.validTests'))
      return;
    }
    const replacedText = generatedTests.cases.map(row => {
      let newText = parameters.testTemplate;
      generatedTests.headers.forEach((header, index) => {
        const placeholder = new RegExp(`\\|${header}\\|`, 'g');

        newText = newText.replace(placeholder, `<b>${row[index]}</b>`);
      });
      return newText

    });

    setParameters((prevState) => {
      return {
        ...prevState,
        testScript: replacedText
      }
    });
    setCurrentTab('script')
  }

  const sample_template = t('Components.NodeLayout.CombinatorialTestPane.testScript.sampleTemplate')

  return (
    <div className={Styles.parentContainer_testScript}>
      <div className={Styles.header}>
        <div
          onClick={() => { setCurrentTab('template') }}
          style={{
            borderBottom: currentTab === 'template' && '2px solid blue',
            fontWeight: currentTab === 'template' && 600
          }}
        >
          {t('Components.NodeLayout.CombinatorialTestPane.testScript.tab.testTemplate')} </div>
        <div
          onClick={() => { setCurrentTab('script') }}
          style={{
            borderBottom: currentTab === 'script' && '2px solid blue',
            fontWeight: currentTab === 'script' && 600
          }}
        >
          {t('Components.NodeLayout.CombinatorialTestPane.testScript.tab.testScripts')} </div>
      </div>
      <div className={Styles.test_script_body}>
        {currentTab === 'template' &&
          <>
            <AivagamButton
              onClick={generateScript}
              buttonText={
                <div style={{ display: 'flex', gap: '0.5em', alignItems: 'center' }}>
                  <FeatherIcon size='1.5em' icon='play' />
                  {t('Components.NodeLayout.CombinatorialTestPane.testScript.button.generate')} </div>
              }
              disabled={parameters.testTemplate === ''}
              classStyles={{ height: 'fit-content', position: 'absolute', right: '1em ', top: '1em' }}
              type='action'
            />
            <textarea onChange={handleTemplateEdit} value={parameters.testTemplate} className={Styles.script_template_input} placeholder={sample_template}>

            </textarea>
          </>
        }
        {currentTab === 'script' &&
          <>
            <div className={Styles.test_scripts_output} >
              {parameters.testScript.length ?

                parameters.testScript.map((script, index) => {
                  return (
                    <div key={`${script}_${index}`} className={Styles.renderedTestCase_container}>
                      <p className={Styles.testScript_index}>{index + 1}.</p>
                      <p className={Styles.testScript} dangerouslySetInnerHTML={{ __html: script }}></p>
                    </div>
                  )
                })
                : <p className={Styles.warningText}><span style={{ color: 'red', marginRight: '0.2em' }}>*</span>{t('Components.NodeLayout.CombinatorialTestPane.testScript.alert.defineTest')}</p>}
            </div>
          </>
        }
      </div>
    </div>
  )
}

